{
  "name": "get-passport",
  "version": "0.200.2a2",
  "scripts": {
    "ng": "ng",
    "start-gmf": "ng serve gmf-dashboard",
    "start-spi": "ng serve spi-dashboard --port 4500",
    "start-paas": "ng serve paas-dashboard --port 4300",
    "build-gmf": "ng build gmf-dashboard && npm run sentry-gmf:sourcemaps && npm run post-build",
    "build-spi": "ng build spi-dashboard && npm run sentry-spi:sourcemaps && npm run post-build",
    "build-paas": "ng build paas-dashboard && npm run post-build",
    "lint-gmf": "ng lint gmf-dashboard --fix",
    "lint-spi": "ng lint spi-dashboard --fix",
    "lint-paas": "ng lint paas-dashboard --fix",
    "prepare-git-hooks": "husky install",
    "build-gmf:ci": "ng build gmf-dashboard --configuration=production --source-map=false --base-href /",
    "build-spi:ci": "ng build spi-dashboard --configuration=production --source-map=false --base-href /",
    "build-paas:ci": "ng build paas-dashboard --configuration=production --source-map=false --base-href /",
    "test-gmf:ci": "ng test gmf-dashboard --watch=false --code-coverage --source-map true",
    "test-spi:ci": "ng test spi-dashboard --watch=false --code-coverage --source-map true",
    "test-paas:ci": "ng test paas-dashboard --watch=false --code-coverage --source-map true",
    "test-e2e:gmf": "ng run gmf-dashboard-e2e:e2e:production-e2e",
    "test-e2e:spi": "ng run spi-dashboard-e2e:e2e:production-e2e",
    "test-e2e:paas": "ng run paas-dashboard-e2e:e2e:production-e2e",
    "start-server-gmf": "node projects/gmf-dashboard/server.mjs",
    "start-server-spi": "node projects/spi-dashboard/server.mjs",
    "start-server-paas": "node projects/paas-dashboard/server.mjs",
    "sentry-spi:sourcemaps": "sentry-cli sourcemaps inject --org passportfintech --project dashboard-spi ./dist/spi-dashboard && sentry-cli sourcemaps upload --org passportfintech --project dashboard-spi ./dist/spi-dashboard",
    "sentry-gmf:sourcemaps": "sentry-cli sourcemaps inject --org passportfintech --project dashboard-gmf ./dist/gmf-dashboard && sentry-cli sourcemaps upload --org passportfintech --project dashboard-gmf ./dist/gmf-dashboard",
    "sentry-paas:sourcemaps": "sentry-cli sourcemaps inject --org passportfintech --project dashboard-paas ./dist/paas-dashboard && sentry-cli sourcemaps upload --org passportfintech --project dashboard-paas ./dist/paas-dashboard",
    "post-build": "rm -rf dist/**/*.js.map"
  },
  "private": true,
  "dependencies": {
    "@abacritt/angularx-social-login": "2.3.0",
    "@angular/animations": "20.3.27",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.27",
    "@angular/compiler": "20.3.27",
    "@angular/core": "20.3.27",
    "@angular/forms": "20.3.27",
    "@angular/material": "20.2.14",
    "@angular/platform-browser": "20.3.27",
    "@angular/platform-browser-dynamic": "20.3.27",
    "@angular/router": "20.3.27",
    "@ant-design/colors": "7.1.0",
    "@ngrx/effects": "20.1.0",
    "@ngrx/entity": "20.1.0",
    "@ngrx/operators": "20.1.0",
    "@ngrx/router-store": "20.1.0",
    "@ngrx/store": "20.1.0",
    "@ngrx/store-devtools": "20.1.0",
    "@ngx-translate/core": "15.0.0",
    "@sentry/angular": "10.27.0",
    "@sentry/cli": "2.58.2",
    "@zxing/browser": "0.1.5",
    "@zxing/library": "0.21.3",
    "@zxing/ngx-scanner": "20.0.0",
    "angularx-qrcode": "20.0.0",
    "compression": "1.8.1",
    "date-fns": "3.6.0",
    "dotenv": "17.2.3",
    "echarts": "^6.1.0",
    "express": "4.22.2",
    "file-saver": "2.0.5",
    "flag-icons": "7.5.0",
    "html2canvas": "1.4.1",
    "libphonenumber-js": "1.12.6",
    "lodash-es": "4.18.1",
    "ng-otp-input": "1.9.3",
    "ng-zorro-antd": "20.1.0",
    "ngx-date-fns": "10.0.1",
    "ngx-echarts": "20.0.2",
    "ngx-markdown": "20.1.0",
    "ngx-permissions": "17.1.0",
    "papaparse": "5.4.1",
    "rxjs": "7.8.0",
    "tslib": "2.8.1",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "20.3.27",
    "@angular-devkit/schematics": "20.3.27",
    "@angular-eslint/builder": "20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/schematics": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular/build": "20.3.31",
    "@angular/cli": "20.3.31",
    "@angular/compiler-cli": "20.3.27",
    "@babel/core": "7.29.7",
    "@commitlint/cli": "19.2.1",
    "@commitlint/config-conventional": "19.1.0",
    "@cypress/schematic": "5.0.0",
    "@ngrx/eslint-plugin": "20.1.0",
    "@ngrx/schematics": "20.1.0",
    "@schematics/angular": "20.3.27",
    "@types/file-saver": "2.0.7",
    "@types/jasmine": "5.1.13",
    "@types/lodash-es": "4.17.12",
    "@types/node": "24.10.1",
    "@typescript-eslint/eslint-plugin": "8.15.0",
    "@typescript-eslint/parser": "8.15.0",
    "babel-loader": "9.1.3",
    "cypress": "15.21.0",
    "eslint": "9.39.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-jsdoc": "61.4.1",
    "eslint-plugin-prettier": "5.1.3",
    "husky": "7.0.4",
    "jasmine-core": "5.1.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "less": "^4.8.1",
    "lint-staged": "15.5.2",
    "prettier": "3.2.5",
    "typescript": "5.9.3"
  },
  "lint-staged": {
    "**/*": "prettier --write --ignore-unknown",
    "*.ts": "eslint --cache --fix"
  },
  "overrides": {
    "canvg": "4.0.3",
    "chevrotain": "12.0.0"
  }
}
